import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, UserPlus, Link2 } from 'lucide-react';
import { toast } from 'sonner';
import CareLayout from './CareLayout';
import { care, fail, rm, can, getUser } from './careApi';
import { Badge, Btn, Card, PageHeader, Table, Select, Loading } from './careUi';

export default function CareResidents() {
  const nav = useNavigate();
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState('');
  const [status, setStatus] = useState('');
  const load = useCallback(() => {
    care.get('/residents', { params: { q: q || undefined, status: status || undefined } }).then((r) => setRows(r.data)).catch(fail);
  }, [q, status]);
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);
  return (
    <CareLayout>
      <PageHeader title="Residents" sub="All registered residents and their admission status.">
        {can('admin', 'staff') && <Btn variant="ghost" onClick={() => { navigator.clipboard.writeText(`${window.location.origin}/care/register/${getUser()?.org_slug || ''}`); toast.success('Online registration link copied'); }} data-testid="residents-copy-register-link"><Link2 className="w-4 h-4" />Copy registration link</Btn>}
        {can('admin', 'staff') && <Btn onClick={() => nav('/care/residents/new')} data-testid="residents-new-btn"><UserPlus className="w-4 h-4" />New registration</Btn>}
      </PageHeader>
      <Card>
        <div className="p-4 flex flex-col sm:flex-row gap-3 border-b border-slate-100">
          <div className="relative flex-1">
            <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, Resident ID, NRIC or room" data-testid="residents-search"
              className="w-full pl-9 pr-3 py-2 rounded-lg border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-teal-600/30" />
          </div>
          <Select value={status} onChange={(e) => setStatus(e.target.value)} testid="residents-status-filter" className="sm:w-48"
            options={[{ value: '', label: 'All statuses' }, 'Draft', 'Pending Approval', 'Active', 'Discharged']} />
        </div>
        {!rows ? <Loading /> : (
          <Table testid="residents-table" rows={rows} onRow={(r) => nav(`/care/residents/${r.id}`)} cols={[
            { k: 'resident_id', h: 'Resident ID', r: (r) => <span className="font-mono text-xs font-semibold">{r.resident_id}</span> },
            { k: 'name', h: 'Name', r: (r) => <span className="font-medium text-slate-900">{r.name}</span> },
            { k: 'room', h: 'Room' }, { k: 'admission_date', h: 'Admission' },
            { k: 'status', h: 'Status', r: (r) => <Badge s={r.status} /> },
            { k: 'admission_status', h: 'Admission docs', r: (r) => <Badge s={r.admission_status} /> },
            { k: 'monthly_amount', h: 'Monthly', right: true, r: (r) => rm(r.monthly_amount) },
          ]} />
        )}
      </Card>
    </CareLayout>
  );
}
